import { PERMISSIONS } from '../../constants'
import list from './GenerateQrcode'

export default {
  list,
  name: 'generate-confirmation-qrcode',
  permissions: [PERMISSIONS.ADMIN, PERMISSIONS.GENERATE_CONFIRMATION_QRCODE],
}
